import React, {useState} from 'react';
import { ToggleBar } from '../toggleBar/toggleBar';
import './style.css';

const DashboardTogglebar = ({ options, onSelectAction }) => {

    return (
        <div class="dashboard-metric-toggle-bar">
            <ToggleBar options={options} onSelectAction={onSelectAction} />
        </div>
    );
}

export { DashboardTogglebar };